type Props = {
  collapsed?: boolean;
};

export default function DashboardIcon({ collapsed }: Props) {
  return (
    <span className="w-6 flex justify-center">
      <svg
        width="16"
        height="17"
        viewBox="0 0 16 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.87454 15.2494V11.4993C9.87454 11.3335 9.80869 11.1746 9.69148 11.0574C9.57427 10.9401 9.4153 10.8743 9.24954 10.8743H6.74954C6.58378 10.8743 6.42481 10.9401 6.3076 11.0574C6.19039 11.1746 6.12454 11.3335 6.12454 11.4993V15.2494C6.12454 15.4151 6.0587 15.5741 5.94151 15.6913C5.82432 15.8085 5.66537 15.8744 5.49962 15.8744L1.75008 15.8749C1.668 15.8749 1.58671 15.8587 1.51088 15.8273C1.43504 15.7959 1.36613 15.7499 1.30809 15.6918C1.25004 15.6338 1.204 15.5649 1.17258 15.4891C1.14117 15.4132 1.125 15.3319 1.125 15.2499V8.0264C1.125 7.93932 1.14319 7.85321 1.17842 7.77358C1.21364 7.69394 1.26511 7.62255 1.32954 7.56397L7.57911 1.88157C7.69415 1.77696 7.84406 1.719 7.99955 1.71899C8.15504 1.71899 8.30495 1.77694 8.42 1.88154L14.6704 7.56397C14.7349 7.62255 14.7863 7.69395 14.8216 7.77358C14.8568 7.85322 14.875 7.93934 14.875 8.02642V15.2499C14.875 15.332 14.8588 15.4132 14.8274 15.4891C14.796 15.5649 14.75 15.6338 14.6919 15.6918C14.6339 15.7499 14.565 15.7959 14.4891 15.8273C14.4133 15.8587 14.332 15.8749 14.2499 15.8749L10.4995 15.8744C10.3337 15.8744 10.1748 15.8085 10.0576 15.6913C9.94038 15.5741 9.87454 15.4151 9.87454 15.2494V15.2494Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
}
